var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "accept-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.961,
    height: 48.961,
    viewBox: "0 0 48.961 48.961",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_103150",
    "data-name": "Path 103150",
    d: "M24.48,0A24.48,24.48,0,1,1,0,24.48,24.48,24.48,0,0,1,24.48,0Z",
    fill: "#3aaf3c",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_103151",
    "data-name": "Path 103151",
    d: "M121.848,143.23h1.839c-7.829,8.694-13.9,15.863-19.334,26.347-2.83-6.049-5.351-10.225-10.993-14.1L95.467,155c4.216,3.449,6.437,7.283,8.887,12.522,5-9.649,10.542-16.49,17.495-24.3Z",
    transform: "translate(-84.432 -129.533)",
    fill: "#0da10d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_103152",
    "data-name": "Path 103152",
    d: "M99.545,132.623a16.836,16.836,0,0,1,4.562,3.591c3.78-6.085,7.883-9.456,13.219-14.242l.521-.2h5.839c-7.829,8.7-13.9,15.864-19.334,26.348-2.83-6.049-5.351-10.225-10.993-14.1l6.185-1.4Z",
    transform: "translate(-84.432 -110.126)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectIcon);
export default __webpack_public_path__ + "static/media/correct-icon.e35ca007b515a154d387c3ced8c2ed2e.svg";
export { ForwardRef as ReactComponent };